import React, { useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import SimpleApiExplorer from '../components/SimpleApiExplorer';
import './PageStyles.css';

const PaymentModes = () => {
  const [showTryApi, setShowTryApi] = useState(false);
  const paymentModes = [
    { id: 1, code: 'BANK_TRANSFER', name: 'Bank Transfer', description: 'Direct bank to bank transfer', status: 'Active', supportedPartners: ['Veem', 'Tazapay', 'Monex'] },
    { id: 2, code: 'WALLET', name: 'Digital Wallet', description: 'Payment through digital wallets', status: 'Active', supportedPartners: ['Viamericas', 'Tazapay'] },
    { id: 3, code: 'CASH_PICKUP', name: 'Cash Pickup', description: 'Cash pickup at agent locations', status: 'Active', supportedPartners: ['Viamericas', 'Monex'] },
    { id: 4, code: 'CARD', name: 'Card Payment', description: 'Credit/Debit card payment', status: 'Active', supportedPartners: ['Veem', 'Tazapay'] },
  ];

  const sampleRequest = {
    code: "MOBILE_MONEY",
    name: "Mobile Money",
    description: "Payment through mobile money services",
    status: "active",
    supported_partners: ["Viamericas", "Tazapay"]
  };

  const sampleResponse = {
    status: "success",
    code: "200",
    message: "Payment mode created successfully",
    data: {
      id: 5,
      code: "MOBILE_MONEY",
      name: "Mobile Money",
      description: "Payment through mobile money services",
      status: "active",
      supported_partners: ["Viamericas", "Tazapay"],
      created_at: "2024-01-15T10:30:00Z"
    },
    request_id: "req_123456789"
  };

  const getListResponse = {
    status: "success",
    code: "200",
    data: [
      { id: 1, code: "BANK_TRANSFER", name: "Bank Transfer", description: "Direct bank to bank transfer", status: "active" },
      { id: 2, code: "WALLET", name: "Digital Wallet", description: "Payment through digital wallets", status: "active" },
    ],
    request_id: "req_123456789"
  };

  const paymentModesTabs = [
    { id: 'get', label: 'Get', method: 'GET', endpoint: '/api/v1/payment-modes', sampleResponse: getListResponse },
    { id: 'add', label: 'Add', method: 'POST', endpoint: '/api/v1/payment-modes', sampleRequest, sampleResponse },
  ];

  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="card">
          <div className="card-header card-header-master">
            <h2>Payment Modes</h2>
            <button type="button" className="btn btn-try-api" onClick={() => setShowTryApi(true)}>
              Try API
            </button>
          </div>
          
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Code</th>
                <th>Name</th>
                <th>Description</th>
                <th>Supported Partners</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paymentModes.map((mode) => (
                <tr key={mode.id}>
                  <td>{mode.id}</td>
                  <td><code>{mode.code}</code></td>
                  <td><strong>{mode.name}</strong></td>
                  <td>{mode.description}</td>
                  <td>{mode.supportedPartners.join(', ')}</td>
                  <td>
                    <span className={`status-badge ${mode.status.toLowerCase()}`}>
                      {mode.status}
                    </span>
                  </td>
                  <td>
                    <button className="btn btn-secondary btn-sm">Edit</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {showTryApi && <div className="try-api-sidebar-overlay" onClick={() => setShowTryApi(false)} aria-hidden="true" />}
        {showTryApi && (
          <aside className="try-api-sidebar">
            <SimpleApiExplorer
              apiName="Payment Modes API"
              tabs={paymentModesTabs}
              onClose={() => setShowTryApi(false)}
            />
          </aside>
        )}
      </div>
    </DashboardLayout>
  );
};

export default PaymentModes;
